import * as code from './code'
import * as date from './date'
import * as host from './host'
import * as url from './url'
import * as lang from './lang'
import * as ui from './ui'
import * as vue from './vue'
import * as api from './api'
import * as biz from './biz'
import * as number from './number'

export default Object.freeze({
  ...code,
  ...date,
  ...host,
  ...url,
  ...lang,
  ...ui,
  ...vue,
  ...api,
  ...biz,
  ...number
})
